import styled from "styled-components"

export const Wrapper = styled.div`
position:relative;
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #326A32;
        border-color: #326A32;
    }   
`